import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Was sagen unsere Kunden</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4">
                <div className="testimonial">
                  <div className="testimonial-content">
                    {/* Die Anführungszeichen stehen bereits in data.json –
                        die zusätzlichen im Markup ergaben doppelte. */}
                    <p>{d.text}</p>
                    <div className="testimonial-meta">{`– ${d.name}`}</div>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
